import React from 'react';
import PropTypes from 'prop-types';

import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Row from '@zg-rentals/multibrand-ui/lib/Row';

import BillingConstants from 'app/shared/constants/BillingConstants';

import './style.scss';

const propTypes = {
    errorMsg: PropTypes.string,
};

const defaultProps = {
    errorMsg: '',
};

const BillingError = ({ errorMsg }) => (
    <div className="BillingError">
        <Row>
            <Col>
                {errorMsg}
            </Col>
        </Row>
        <Row>
            <Col>
                <Text>
                    Please contact Zillow Group Rentals.
                </Text>
                <Text>
                    {`Tel: ${BillingConstants.ZRN_BILLING_PHONE}, Email ${BillingConstants.ZRN_BILLING_EMAIL}`}
                </Text>
            </Col>
        </Row>
    </div>
);

BillingError.propTypes = propTypes;
BillingError.defaultProps = defaultProps;

export default BillingError;
